import { i18n } from '../../utils';
import { eventStateLabel } from 'utils/eventStateLabel';

export const normalizeDataTable = (evntsList: any) => {
  const data = evntsList?.item;
  if (data) {
    return data.items.map((item: any) => ({
      patientId: item.patientId,
      date: item.eventTimestamp,
      user: `${item.patientName.firstName !== null ? item.patientName.firstName : ''} ${item.patientName.middleName !== null ? item.patientName.middleName : ''} ${item.patientName.lastName !== null ? item.patientName.lastName : ''}`,
      userAccess: item.patientAccess,
      firstName: item.patientName.firstName !== null ? item.patientName.firstName : '',
      middleName: item.patientName.middleName !== null ? item.patientName.middleName : '',
      lastName: item.patientName.lastName !== null ? item.patientName.lastName : '',
      actionType: i18n(item.eventType),
      rawActionType: item.eventType,
      alarmState: eventStateLabel(item),
      rawAlarmState: item.eventState,
      patientServiceNumber: item.patientServiceNumber,
      destinationNumber: item.destinationNumber,
      deviceActionId: item.eventId,
      deviceId: item.deviceId,
      deviceTypeCode: item.deviceTypeCode,
      devicePeripheralId: item.devicePeripheralId,
      devicePeripheralTypeCode: item.devicePeripheralTypeCode,
      patientGroup: item.patientGroup,
      group: item.patientGroup.code,
      lastDeviceLocation: item.lastDeviceLocation,
      resolved: !!item.resolution.resolution.id,
      resolutionId: item.resolution.resolution.id,
      resolutionTimestamp: item.resolution.timestamp,
      measureRawId: item.measureRawId,
      reference: item.reference,
      applicantName: item.resolution.applicantName,
      expedientId: item.expedientId,
    }));
  }
  return []
};

export const normalizeDataEvent = (event: any) => {
  const item = event?.data?.item;
  if (item) {
    return {
      patientId: item.patientId,
      date: item.eventTimestamp,
      user: `${item.patientName.firstName !== null ? item.patientName.firstName : ''} ${item.patientName.middleName !== null ? item.patientName.middleName : ''} ${item.patientName.lastName !== null ? item.patientName.lastName : ''}`,
      userAccess: item.patientAccess,
      firstName: item.patientName.firstName !== null ? item.patientName.firstName : '',
      middleName: item.patientName.middleName !== null ? item.patientName.middleName : '',
      lastName: item.patientName.lastName !== null ? item.patientName.lastName : '',
      actionType: i18n(item.eventType),
      alarmState: i18n(item.eventState),
      rawActionType: item.eventType,
      patientServiceNumber: item.patientServiceNumber,
      deviceActionId: item.eventId,
      deviceId: item.deviceId,
      deviceTypeCode: item.deviceTypeCode,
      patientGroup: item.patientGroup,
      group: item.patientGroup.code,
      lastDeviceLocation: item.lastDeviceLocation,
      resolved: !!item.resolution.resolution.id,
      resolutionId: item.resolution.resolution.id,
      resolutionTimestamp: item.resolution.timestamp,
      measureRawId: item.measureRawId,
      reference: item.reference,
      applicantName: item.resolution.applicantName,
    };
  }
  return []
};

//actionType: item.alarmType ? i18n(item.alarmType) : '',
  //alarmState: item.alarmState ? i18n(item.alarmState) : '',

export const updateResolve = (newData: any, userList: any) => {
  return userList.map((item: any) => {
    if (newData.arg.id === item.deviceActionId) {
      return {
        ...item,
        resolved: newData.arg.params.resolved,
      };
    }
    return item;
  });
}